import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    searchPlaceholder: "Buscar eventos…",
    filters: "Filtros",
    all: "Todas",
    title: "Explorar eventos",
    loading: "Cargando…",
    results: (n: number) => `${n} resultado${n !== 1 ? "s" : ""}`,
    organizerCta: "¿Organizas eventos? Publica gratis",
    noResults: "Sin resultados con esos filtros.",
    noResultsHint: "Prueba con otra fecha o categoría.",
    loadMore: "Cargar más eventos",
    seeResults: "Ver resultados",
    district: "Ubicación",
    loadError: "No se pudo cargar",
    allDistricts: "Todas las ubicaciones",
    searchDistrict: "Buscar ubicación…",
    organization: "Organización",
    allOrganizations: "Todas las organizaciones",
    searchOrganization: "Buscar organización…",
    when: "Cuándo",
    anytime: "Cualquier momento",
    today: "Hoy",
    weekend: "Este fin de semana",
    price: "Precio",
    allPrices: "Todos",
    free: "Gratis",
    paid: "De pago",
    unspecified: "Sin especificar",
    search: "Buscar…",
    noMatches: "Sin resultados",
    selected: (n: number) => `${n} seleccionadas`,
    clearSelection: "Limpiar selección",
  },
  en: {
    searchPlaceholder: "Search events…",
    filters: "Filters",
    all: "All",
    title: "Explore events",
    loading: "Loading…",
    results: (n: number) => `${n} result${n !== 1 ? "s" : ""}`,
    organizerCta: "Organize events? Post for free",
    noResults: "No results with these filters.",
    noResultsHint: "Try another date or category.",
    loadMore: "Load more events",
    seeResults: "See results",
    district: "Location",
    loadError: "Couldn't load",
    allDistricts: "All locations",
    searchDistrict: "Search location…",
    organization: "Organization",
    allOrganizations: "All organizations",
    searchOrganization: "Search organization…",
    when: "When",
    anytime: "Any time",
    today: "Today",
    weekend: "This weekend",
    price: "Price",
    allPrices: "All",
    free: "Free",
    paid: "Paid",
    unspecified: "Not specified",
    search: "Search…",
    noMatches: "No results",
    selected: (n: number) => `${n} selected`,
    clearSelection: "Clear selection",
  },
});
